import { lazy } from 'react';

import type { RouteConfig } from '../../types';

const DashboardLayout = lazy(() => import('@/layouts/DashboardLayout'));
const UserAssessmentLayout = lazy(() => import('@/pages/userAssessment/layout'));
const UserAssessmentPage = lazy(() => import('@/pages/userAssessment'));

/**
 * UG-4506 — the standalone assessor wizard (legacy
 * `app/(dashboard)/user-assessment/page.tsx`). Single page: the
 * technician → client → form steps are in-page state, not routes.
 * Permission: `/user-assessment` → `users.userAssessments.canAssessUser` in
 * `@/config/auth/routeAccess` (legacy parity). `UserAssessmentLayout` mounts
 * the section breadcrumb.
 */
export const userAssessmentRoutes: RouteConfig = {
  path: '/user-assessment',
  layout: DashboardLayout,
  children: [{ path: '', layout: UserAssessmentLayout, element: UserAssessmentPage }],
};
